<template>
  <div class="mx-5 mt-4">
    <img :src="image.url" :alt="image.alt" class="block h-auto w-full rounded-2xl" />
  </div>
</template>

<script>
export default {
  name: 'EventKeyVisual',
  props: {
    image: {
      type: Object,
      required: true,
    },
  },
};
</script>
